define(function () {
	'use strict';

	/**
	 * Context enum
	 */
	return {
		SERVICE_PROVIDER : 'Service Provider',
		CLOUD_IDENTITIES_MANAGEMENT : 'Cloud Identities Management',
		FINISH_AUTH : 'Finish Authentication'
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/model/Context.js
// module id = 32
// module chunks = 2